import * as Actions from './type';
import {
  getLaborClassListApi,
  createLaborClassApi,
  updateLaborClassApi,
  deleteLaborClassApi,
} from '../../api/laborClass/labor-class-apis';

export const getLaborClasses = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_LABOR_CLASS_LISTING_REQUEST,
    });

    const { data } = await getLaborClassListApi();

    dispatch({
      type: Actions.GET_LABOR_CLASS_LISTING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_LABOR_CLASS_LISTING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createLaborClass = (classData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.CREATE_LABOR_CLASS_REQUEST,
    });

    const { data } = await createLaborClassApi(classData);

    dispatch({
      type: Actions.CREATE_LABOR_CLASS_SUCCESS,
      payload: data,
    });
    dispatch({
      type: Actions.UPDATE_LABOR_CLASS_LIST,
      payload: data,
      insert: true,
    });
  } catch (error) {
    dispatch({
      type: Actions.CREATE_LABOR_CLASS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateLaborClass = (updatedData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_LABOR_CLASS_REQUEST,
    });

    const { data } = await updateLaborClassApi(updatedData);

    dispatch({
      type: Actions.UPDATE_LABOR_CLASS_SUCCESS,
      payload: data,
    });
    dispatch({
      type: Actions.UPDATE_LABOR_CLASS_LIST,
      payload: data,
      update: true,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_LABOR_CLASS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteLaborClass = (item) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_LABOR_CLASS_REQUEST,
    });

    const { data } = await deleteLaborClassApi(item);

    dispatch({
      type: Actions.DELETE_LABOR_CLASS_SUCCESS,
      payload: data,
    });
    dispatch({
      type: Actions.UPDATE_LABOR_CLASS_LIST,
      payload: data,
      delete: true,
    });
  } catch (error) {
    dispatch({
      type: Actions.DELETE_LABOR_CLASS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
